export default "__VITE_ASSET__nb8Qg4GW__"